const META_PIXEL_ID = '1737548657531236';
const META_PIXEL_SCRIPT_ID = 'meta-pixel-script';
const META_PIXEL_NOSCRIPT_ID = 'meta-pixel-noscript';

type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}

export function initializeMetaPixel() {
  if (document.getElementById(META_PIXEL_SCRIPT_ID)) return;

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  } as MetaPixelFunction;

  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement('script');
  script.id = META_PIXEL_SCRIPT_ID;
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  fbq('init', META_PIXEL_ID);
  fbq('track', 'PageView');

  const noscript = document.createElement('noscript');
  noscript.id = META_PIXEL_NOSCRIPT_ID;

  const image = document.createElement('img');
  image.height = 1;
  image.width = 1;
  image.alt = '';
  image.style.display = 'none';
  image.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
  noscript.appendChild(image);
  document.body.appendChild(noscript);
}